import { render, staticRenderFns } from "./Days.vue?vue&type=template&id=098d1c28&"
import script from "./Days.vue?vue&type=script&lang=js&"
export * from "./Days.vue?vue&type=script&lang=js&"
import style0 from "./Days.vue?vue&type=style&index=0&id=098d1c28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports